import type { UseFormReturn } from 'react-hook-form';
import { Labeled, Select, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IOrganizationInvitationFormValues } from './OrganizationInvitationForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { OrganizationRoleSelector } from '~/components/organisms/fields/OrganizationRoleSelector';
import { OrganizationSelector } from '~/components/organisms/fields/OrganizationSelector';

export type IOrganizationInvitationFormMainSectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IOrganizationInvitationFormValues>;
};

export const OrganizationInvitationFormMainSection: React.FC<
  IOrganizationInvitationFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled label={t('common.organization')} required readOnly>
        <FormField
          name="organizationId"
          control={form.control}
          as={OrganizationSelector}
        />
      </Labeled>
      <Labeled
        label={t('common.emailAddress')}
        supportingText={t(
          'OrganizationInvitationFormMainSection.field.email-address.supporting-text',
        )}
        required
      >
        <FormField
          name="email"
          control={form.control}
          as={TextInputField}
          forwardError
          type="email"
        />
      </Labeled>
      <Labeled
        label={t('common.role')}
        supportingText={t(
          'OrganizationInvitationFormMainSection.field.role.supporting-text',
        )}
        required
      >
        <FormField
          name="role"
          control={form.control}
          as={OrganizationRoleSelector}
          forwardError
        />
      </Labeled>
      <Labeled
        label={t('OrganizationInvitationFormMainSection.field.language.label')}
        supportingText={t(
          'OrganizationInvitationFormMainSection.field.language.supporting-text',
        )}
        required
      >
        <FormField
          name="language"
          control={form.control}
          as={Select}
          forwardError
          items={[
            { value: 'en', label: t('common.english') },
            { value: 'fr', label: t('common.french') },
          ]}
        />
      </Labeled>
    </FormSection>
  );
};
